export const PAYMENT_CONCEPTS = {
  CUOTA: "cuota",
  EXTRA_HOURS: "horas_adicionales",
  INTERNSHIP: "pasantias",
} as const;

export type PaymentConcept =
  (typeof PAYMENT_CONCEPTS)[keyof typeof PAYMENT_CONCEPTS];

export const PAYMENT_CONCEPT_LABELS: Record<PaymentConcept, string> = {
  [PAYMENT_CONCEPTS.CUOTA]: "Cuota mensual",
  [PAYMENT_CONCEPTS.EXTRA_HOURS]: "Horas adicionales",
  [PAYMENT_CONCEPTS.INTERNSHIP]: "Pasantías",
};

export function isSupplementalPaymentConcept(
  concept?: PaymentConcept | string | null
): boolean {
  return (
    concept === PAYMENT_CONCEPTS.EXTRA_HOURS ||
    concept === PAYMENT_CONCEPTS.INTERNSHIP
  );
}

export function normalizeProgramName(name?: string | null): string {
  if (!name) return "";
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function isCosmetologyProgramName(name?: string | null): boolean {
  return normalizeProgramName(name).includes("cosmetolog");
}

export function getPaymentConceptLabel(
  concept?: PaymentConcept | string | null
): string {
  if (!concept || !(concept in PAYMENT_CONCEPT_LABELS)) {
    return PAYMENT_CONCEPT_LABELS[PAYMENT_CONCEPTS.CUOTA];
  }
  return PAYMENT_CONCEPT_LABELS[concept as PaymentConcept];
}

export function resolvePaymentConcept(
  concept?: PaymentConcept | string | null
): PaymentConcept {
  if (concept && concept in PAYMENT_CONCEPT_LABELS) {
    return concept as PaymentConcept;
  }
  return PAYMENT_CONCEPTS.CUOTA;
}
